import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../common/GridLayout";

import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";

const ItemSerialNumbersSubTab = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const childRef = useRef();
    const allowedPageSizes = [25, 50, 100, 500, 1000, "all"];
    const gridKey = "EF49AE83-6172-4D1D-9CED-1352A1C32B3A";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
        }
    };

    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <ColumnHeaderFilter />
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={25} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <FilterRow visible={true} />
                <Scrolling mode="virtual" />
                <Column dataField="serialNumber" caption="Serial Number" visible={true} />
                <Column dataField="netWeight" caption="Net Weight" visible={true} />
                <Column dataField="grossWeight" caption="Gross Weight" visible={true} />
                <Column dataField="size1" caption="Size 1" visible={true} />
                <Column dataField="size2" caption="Size 2" visible={true} />
                <Column dataField="userDefinedReference1" caption="Reference" visible={true} />
                <Column dataField="packageId" caption="Package" visible={true} />
                <Column dataField="inTransactionNumber" caption="In-Transaction#" visible={false} />
                <Column dataField="inTransactionDate" caption="In-Transaction Date" visible={false} />
                <Column dataField="outTransactionNumber" caption="Out-Transaction#" visible={false} />
                <Column dataField="outTransactionDate" caption="Out-Transaction Date" visible={false} />
                <Column dataField="userDefinedCode1" caption="Code 1" visible={false} />
                <Column dataField="damageFlag" caption="Damage Flag" visible={false} />
                <Column dataField="damageDescription" caption="Damage Description" visible={false} />
                <Column dataField="comment" caption="Comment" visible={false} />
                <Column dataField="receiptVerified" caption="Receipt Verified" visible={false} />
                <Column dataField="shipmentVerified" caption="Shipment Verified" visible={false} />
                <Column dataField="originalNetWeight" caption="Original Net Weight" visible={false} />
                <Column dataField="originalGrossWeight" caption="Original Gross Weight" visible={false} />
                <Column dataField="userDefinedReference2" caption="Reference 2" visible={false} />
                <Column dataField="userDefinedReference3" caption="Reference 3" visible={false} />
                <Column dataField="userDefinedReference4" caption="Reference 4" visible={false} />
                <Column dataField="userDefinedReference5" caption="Reference 5" visible={false} />
                <Column dataField="ssccLabel" caption="SSCC Label" visible={false} />
                <Column dataField="itemCode" caption="Item Code" visible={false} />
                <Column dataField="itemDescription1" caption="Description 1" visible={false} />
                <Column dataField="itemDescription2" caption="Description 2" visible={false} />
                <Column dataField="itemClass" caption="Class" visible={false} />
                <Column dataField="itemSubClass" caption="Sub Class" visible={false} />
                <Column dataField="itemType" caption="Item Type" visible={false} />
                <Column dataField="creationdatetime" caption="Creation datetime" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="creationuserid" caption="Created By" visible={false} />
                <Column dataField="lastupdatedatetime" caption="Lastupdate datetime"  dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="lastupdateuserid" caption="LastupdatedBy" visible={false} />
                <Toolbar>

                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ItemSerialNumbersSubTab);